module.exports = __webpack_public_path__ + "static/media/accordion-slider_codepen.35b197f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/codepen-imgs/accordion-slider_codepen.jpg
// module id = 76
// module chunks = 0